export const THEME_COLORS = {
    logsTimestamp: "#e8e8e8",
    scrollbarThumb: "#616161",
    logContent: "#ddd",
    dataViewBackground: "#1a1a1a",
    emptyViewMessage: "#aaa",
};

export const LEVEL_COLORS = {
    critical: "purple",
    error: "red",
    warning: "orange",
    info: "green",
    debug: "blue",
    trace: "lightblue",
    unknown: "gray",
};
